export default {
  nhap_tu_khoa: "Enter keywords.",
  start: "Start point",
  end: "Destination",
  chon_ngay_di: 'Departure date',
  tim_ve: 'Find tickets',
  cam_ket: 'Commit to refund 150% if the bus operator does not keep the ticket',
  loc: 'Filter',
  xoa_loc: 'Clear filter',
  gio_di: 'Time going',
  nha_xe: 'Bus Company',
  gia_ve: 'Fare',
  danh_gia: 'Evaluate',
  tro_len: 'or more',
  sang_som: 'Early morning',
  buoi_sang: 'Morning',
  buoi_chieu: 'Afternoon',
  buoi_toi: 'Evening',
  bo_loc: 'Filter',
  list_empty: 'The list is empty',
  no_result: 'Not found',
  states_cities: 'States - Cities',
  districts: 'Districts',
  close: 'Close',
  tickets_booking: 'Sleeper Bus Tickets Booking',
};
